import type { DictFragment } from '../translations';

/** Timeline + Prequalification panels. Namespaces: timeline. / prequal. */
export const projectParts: DictFragment = {
  fr: {
    // ── timeline. (ProjectTimeline) ──
    'timeline.heading': "Chronologie ({n})",
    'timeline.limitedView': "Vue limitée",
    'timeline.refreshTitle': "Actualiser les événements du calendrier et les transcriptions",
    'timeline.syncing': "Synchronisation…",
    'timeline.addMeeting': "Ajouter une réunion",
    'timeline.meetingSubject': "Objet de la réunion",
    'timeline.locationOptional': "Lieu (facultatif)",
    'timeline.attendeesPlaceholder': "Participants (noms séparés par des virgules)",
    'timeline.noActivity': "Aucune activité pour le moment.",
    'timeline.upcoming': "À venir",
    'timeline.past': "Passé",
    'timeline.entriesCount': "{n} entrées",
    'timeline.reply': "Répondre",
    'timeline.replyOne': "{n} réponse",
    'timeline.replyMany': "{n} réponses",
    'timeline.cancelled': "Annulé",
    'timeline.transcript': "Transcription",
    'timeline.noTranscript': "Aucune transcription",
    'timeline.join': "Rejoindre",
    'timeline.unlinkTranscription': "Dissocier la transcription",
    'timeline.attachFile': "Joindre un fichier",
    'timeline.sourceManual': "Manuel · {name}",
    'timeline.sourceDummy': "Factice",
    'timeline.unknown': "Inconnu",
    'timeline.deleteMeeting': "Supprimer la réunion",
    'timeline.noDate': "Aucune date",
    'timeline.viewTranscript': "Voir la transcription",
    'timeline.linkToEvent': "Associer à un événement du calendrier",
    'timeline.deleteEvent': "Supprimer l'événement",
    'timeline.by': "par {name}",
    'timeline.editCommentPlaceholder': "Modifier le commentaire…",
    'timeline.editReplyPlaceholder': "Modifier la réponse…",
    'timeline.eventProjectCreated': "Projet créé",
    'timeline.eventProjectCreatedCode': "Projet créé ({code})",
    'timeline.eventTitleChanged': "Titre modifié de « {old} » à « {new} »",
    'timeline.eventFieldChanged': "Modifié — {field} : {value}",
    'timeline.eventSponsorChanged': "Sponsor modifié de {old} à {new}",
    'timeline.eventSponsorSet': "Sponsor défini sur {new}",
    'timeline.eventCollaboratorAdded': "{name} ajouté comme collaborateur",
    'timeline.eventCollaboratorAddedAlloc': "{name} ajouté comme collaborateur ({n}%)",
    'timeline.eventCollaboratorRemoved': "{name} retiré des collaborateurs",
    'timeline.eventAllocationChanged': "Allocation de {name} modifiée de {old}% à {new}%",
    'timeline.eventStatusChanged': "Statut modifié de {old} à {new}",
    'timeline.eventProjectClosed': "Projet clôturé",
    'timeline.eventTaskCreated': "Tâche « {title} créée",
    'timeline.eventTaskDeleted': "Tâche « {title} supprimée",
    'timeline.eventTaskAssigned': "Tâche « {title} assignée à {name}",
    'timeline.eventTaskCollaboratorAdded': "{name} ajouté·e comme collaborateur·rice de la tâche « {title}",
    'timeline.eventTaskMadePrivate': 'Tâche « {title} rendue privée',
    'timeline.eventTaskMadePublic': 'Tâche « {title} rendue publique',
    'timeline.eventTaskStatusChanged': "Tâche « {title} → {column}",
    'timeline.eventTaskMigratedIn': "Tâche « {title} migrée depuis {project}",
    'timeline.eventTaskMigratedOut': "Tâche « {title} migrée vers {project}",
    'timeline.eventMilestoneAdded': 'Jalon {n} « {name} » ajouté',
    'timeline.eventMilestoneCancelled': 'Jalon « {name} » annulé',
    'timeline.eventMilestoneCancelledTasks': 'Jalon « {name} » annulé — {n} tâche(s) archivée(s)',
    'timeline.eventMilestoneRestored': 'Jalon « {name} » restauré',
    'timeline.eventMilestoneRestoredTasks': 'Jalon « {name} » restauré — {n} tâche(s) sortie(s) des archives',
    'timeline.restoreMilestone': 'Restaurer le jalon',
    'timeline.restoreMilestoneHelp': 'Annuler cette annulation : le jalon est rouvert',
    'timeline.restoreMilestoneTitle': 'Restaurer le jalon ?',
    'timeline.restoreMilestoneMessage': 'Le jalon « {name} » sera rouvert, avec son statut d’avant l’annulation.',
    'timeline.restoreMilestoneMessageTasks': 'Le jalon « {name} » sera rouvert, avec son statut d’avant l’annulation, et ses {n} tâche(s) archivée(s) retourneront dans leur colonne d’origine (sauf celles déplacées depuis).',
    'timeline.uploadFailed': "Échec du téléversement",
    'timeline.deleteFailed': "Échec de la suppression",
    'timeline.createMeetingFailed': "Échec de la création de la réunion",
    'timeline.deleteMeetingFailed': "Échec de la suppression de la réunion",
    'timeline.deleteEventFailed': "Échec de la suppression de l'événement",
    'timeline.linkFailed': "Échec de l'association",
    'timeline.unlinkFailed': "Échec de la dissociation",
    'timeline.deleteRecording': "Supprimer l'enregistrement",
    'timeline.deleteRecordingTitle': "Supprimer l'enregistrement ?",
    'timeline.deleteRecordingWhich': "Enregistrement du {date}, {span}.",
    'timeline.deleteRecordingMessage': "L'enregistrement et sa transcription sont supprimés ici et dans Speakr. Les commentaires et fichiers ajoutés restent sur la réunion.",
    'timeline.deleteRecordingMessageNoMeeting': "L'enregistrement et sa transcription sont supprimés ici et dans Speakr. Les commentaires et fichiers ajoutés restent dans le projet.",
    'timeline.deleteRecordingFailed': "Échec de la suppression de l'enregistrement",

    // ── prequal. (PrequalificationPanels) ──
    'prequal.criticalityTitle': "Criticalité {label} (0–1 : à quel point cette ressource est critique pour la capacité)",
    'prequal.addAsNew': "Ajouter « {q} » comme nouveau",
    'prequal.resource': "Ressource",
    'prequal.maturityHeaderTitle': "Maturité de la ressource 1–5 (actuelle → cible à l'achèvement)",
    'prequal.maturityArrow': "Maturité →",
    'prequal.criticalityHeaderTitle': "À quel point cette ressource est critique pour la capacité (0–1)",
    'prequal.criticality': "Criticalité",
    'prequal.new': "Nouveau",
    'prequal.newResourceTitle': "Pas encore dans RCAJO — sera créé lorsque vous pousserez les nouveaux éléments",
    'prequal.rcajoDescription': "Description RCAJO",
    'prequal.removeResource': "Retirer la ressource",
    'prequal.strategicVerification': "Vérification stratégique (RCAJO)",
    'prequal.removeStrategicLabel': "Retirer l'étiquette Stratégique",
    'prequal.markStrategicTitle': "Marquer ce projet comme Stratégique",
    'prequal.strategicOn': "★ Stratégique",
    'prequal.strategicMark': "☆ Marquer stratégique",
    'prequal.strategic': "Stratégique",
    'prequal.suggesting': " Suggestion…",
    'prequal.suggestWithPistache': " Suggérer avec pistache",
    'prequal.aiSuggestionFailed': "Échec de la suggestion IA",
    'prequal.inventoryUnavailable': "Inventaire RCAJO indisponible — vous pouvez tout de même ajouter des éléments par leur nom et les pousser vers RCAJO plus tard.",
    'prequal.assessmentNotes': "Notes d'évaluation",
    'prequal.assessmentNotesPlaceholder': "Notes appuyant l'évaluation stratégique…",
    'prequal.noNotes': "Aucune note.",
    'prequal.noCapabilities': "Aucune capacité cartographiée pour le moment.",
    'prequal.noCapabilitiesEdit': "Ajoutez-en une ci-dessous ou demandez à pistache de suggérer une évaluation stratégique.",
    'prequal.addCapabilityPlaceholder': "Ajouter une capacité — tapez pour rechercher dans RCAJO ou saisissez un nouveau nom",
    'prequal.standaloneResources': "Ressources (non liées à une capacité)",
    'prequal.addResourcePlaceholder': "Ajouter une ressource — tapez pour rechercher dans RCAJO ou saisissez un nouveau nom",
    'prequal.pushNewItems': "Pousser les nouveaux éléments vers RCAJO",
    'prequal.pushResultPartial': "{pushed} élément(s) poussé(s) ; {failed} en échec.",
    'prequal.pushResultOk': "{pushed} nouvel(aux) élément(s) poussé(s) vers RCAJO.",
    'prequal.maturityShort': "maturité {score}",
    'prequal.newCapabilityBadge': "Nouveau → sera ajouté à RCAJO",
    'prequal.removeCapability': "Retirer la capacité",
    'prequal.noResources': "Aucune ressource cartographiée.",
    'prequal.askPistacheTitle': "Laisser pistache rédiger la raison de cette dépendance",
    'prequal.askPistache': "Demander à pistache",
    'prequal.reasonPlaceholder': "Pourquoi ? Saisissez une raison ou cliquez sur « Demander à pistache ».",
    'prequal.notInExecution': "Pas encore en Exécution",
    'prequal.executionCompleted': "Exécution terminée",
    'prequal.pmoStatusTitle': "Statut évalué par le PMO (Exécution)",
    'prequal.problemGoalDeliverables': "Problème · Objectif · Livrables",
    'prequal.problemNeed': "Problème / Besoin",
    'prequal.goal': "Objectif",
    'prequal.deliverables': "Livrables",
    'prequal.pipelineStageTitle': "Étape actuelle du pipeline",
    'prequal.notInRcajo': "pas dans RCAJO",
    'prequal.notInRcajoTitle': "Référencé par son nom ; absent de l'inventaire RCAJO",
    'prequal.noPredecessors': "aucun prédécesseur",
    'prequal.noSuccessors': "aucun successeur",
    'prequal.thisProject': "Ce projet",
    'prequal.dependenciesSequencing': "Dépendances et séquençage",
    'prequal.checking': " Vérification…",
    'prequal.checkWithPistache': " Vérifier avec pistache",
    'prequal.sequencingCheckFailed': "Échec de la vérification du séquençage",
    'prequal.flow': "Flux",
    'prequal.dependsOnProjects': "Dépend de — projets",
    'prequal.enablesProjects': "Rend possible — projets",
    'prequal.declaredElsewhere': "Déclaré depuis l'autre projet",
    'prequal.addProjectPlaceholder': "Ajouter un projet — tapez pour rechercher",
    'prequal.addResourceSearchPlaceholder': "Ajouter une ressource — tapez pour rechercher dans RCAJO",
    'prequal.referenceNotInRcajo': "Référencer « {q} » (absent de RCAJO)",
    'prequal.doNow': "À faire maintenant",
    'prequal.sequenceLater': "À séquencer plus tard",
    'prequal.suggestedPredecessors': "Prédécesseurs suggérés :",
  },
  en: {
    // ── timeline. (ProjectTimeline) ──
    'timeline.heading': "Timeline ({n})",
    'timeline.limitedView': "Limited view",
    'timeline.refreshTitle': "Refresh calendar events and transcriptions",
    'timeline.syncing': "Syncing...",
    'timeline.addMeeting': "Add meeting",
    'timeline.meetingSubject': "Meeting subject",
    'timeline.locationOptional': "Location (optional)",
    'timeline.attendeesPlaceholder': "Attendees (comma-separated names)",
    'timeline.noActivity': "No activity yet.",
    'timeline.upcoming': "Upcoming",
    'timeline.past': "Past",
    'timeline.entriesCount': "{n} entries",
    'timeline.reply': "Reply",
    'timeline.replyOne': "{n} reply",
    'timeline.replyMany': "{n} replies",
    'timeline.cancelled': "Cancelled",
    'timeline.transcript': "Transcript",
    'timeline.noTranscript': "No transcript",
    'timeline.join': "Join",
    'timeline.unlinkTranscription': "Unlink transcription",
    'timeline.attachFile': "Attach file",
    'timeline.sourceManual': "Manual · {name}",
    'timeline.sourceDummy': "Dummy",
    'timeline.unknown': "Unknown",
    'timeline.deleteMeeting': "Delete meeting",
    'timeline.noDate': "No date",
    'timeline.viewTranscript': "View transcript",
    'timeline.linkToEvent': "Link to calendar event",
    'timeline.deleteEvent': "Delete event",
    'timeline.by': "by {name}",
    'timeline.editCommentPlaceholder': "Edit comment...",
    'timeline.editReplyPlaceholder': "Edit reply...",
    'timeline.eventProjectCreated': "Project created",
    'timeline.eventProjectCreatedCode': "Project created ({code})",
    'timeline.eventTitleChanged': 'Title changed from "{old}" to "{new}"',
    'timeline.eventFieldChanged': 'Changed — {field}: {value}',
    'timeline.eventSponsorChanged': "Sponsor changed from {old} to {new}",
    'timeline.eventSponsorSet': "Sponsor set to {new}",
    'timeline.eventCollaboratorAdded': "{name} added as collaborator",
    'timeline.eventCollaboratorAddedAlloc': "{name} added as collaborator ({n}%)",
    'timeline.eventCollaboratorRemoved': "{name} removed from collaborators",
    'timeline.eventAllocationChanged': "{name} allocation changed from {old}% to {new}%",
    'timeline.eventStatusChanged': "Status changed from {old} to {new}",
    'timeline.eventProjectClosed': "Project closed",
    'timeline.eventTaskCreated': 'Task "{title} created',
    'timeline.eventTaskDeleted': 'Task "{title} deleted',
    'timeline.eventTaskAssigned': 'Task "{title} assigned to {name}',
    'timeline.eventTaskCollaboratorAdded': '{name} added as collaborator on task "{title}',
    'timeline.eventTaskMadePrivate': 'Task "{title} made private',
    'timeline.eventTaskMadePublic': 'Task "{title} made public',
    'timeline.eventTaskStatusChanged': 'Task "{title} → {column}',
    'timeline.eventTaskMigratedIn': 'Task "{title} moved from {project}',
    'timeline.eventTaskMigratedOut': 'Task "{title} moved to {project}',
    'timeline.eventMilestoneAdded': 'Milestone {n} "{name}" added',
    'timeline.eventMilestoneCancelled': 'Milestone "{name}" cancelled',
    'timeline.eventMilestoneCancelledTasks': 'Milestone "{name}" cancelled — {n} task(s) archived',
    'timeline.eventMilestoneRestored': 'Milestone "{name}" restored',
    'timeline.eventMilestoneRestoredTasks': 'Milestone "{name}" restored — {n} task(s) taken out of the archive',
    'timeline.restoreMilestone': 'Restore milestone',
    'timeline.restoreMilestoneHelp': 'Undo this cancellation: the milestone is reopened',
    'timeline.restoreMilestoneTitle': 'Restore the milestone?',
    'timeline.restoreMilestoneMessage': 'Milestone "{name}" will be reopened, with its status from before the cancellation.',
    'timeline.restoreMilestoneMessageTasks': 'Milestone "{name}" will be reopened, with its status from before the cancellation, and its {n} archived task(s) will return to their former column (except those moved since).',
    'timeline.uploadFailed': "Upload failed",
    'timeline.deleteFailed': "Delete failed",
    'timeline.createMeetingFailed': "Failed to create meeting",
    'timeline.deleteMeetingFailed': "Failed to delete meeting",
    'timeline.deleteEventFailed': "Failed to delete event",
    'timeline.linkFailed': "Link failed",
    'timeline.unlinkFailed': "Unlink failed",
    'timeline.deleteRecording': "Delete the recording",
    'timeline.deleteRecordingTitle': "Delete the recording?",
    'timeline.deleteRecordingWhich': "Recording of {date}, {span}.",
    'timeline.deleteRecordingMessage': "The recording and its transcript are deleted here and in Speakr. Comments and files added to it stay on the meeting.",
    'timeline.deleteRecordingMessageNoMeeting': "The recording and its transcript are deleted here and in Speakr. Comments and files added to it stay in the project.",
    'timeline.deleteRecordingFailed': "Failed to delete the recording",

    // ── prequal. (PrequalificationPanels) ──
    'prequal.criticalityTitle': "Criticality {label} (0–1: how critical this resource is to the capability)",
    'prequal.addAsNew': 'Add "{q}" as new',
    'prequal.resource': "Resource",
    'prequal.maturityHeaderTitle': "Resource maturity 1–5 (current → target on completion)",
    'prequal.maturityArrow': "Maturity →",
    'prequal.criticalityHeaderTitle': "How critical this resource is to the capability (0–1)",
    'prequal.criticality': "Criticality",
    'prequal.new': "New",
    'prequal.newResourceTitle': "Not in RCAJO yet — will be created when you push new items",
    'prequal.rcajoDescription': "RCAJO description",
    'prequal.removeResource': "Remove resource",
    'prequal.strategicVerification': "Strategic Verification (RCAJO)",
    'prequal.removeStrategicLabel': "Remove the Strategic label",
    'prequal.markStrategicTitle': "Mark this project as Strategic",
    'prequal.strategicOn': "★ Strategic",
    'prequal.strategicMark': "☆ Mark strategic",
    'prequal.strategic': "Strategic",
    'prequal.suggesting': " Suggesting…",
    'prequal.suggestWithPistache': " Suggest with pistache",
    'prequal.aiSuggestionFailed': "AI suggestion failed",
    'prequal.inventoryUnavailable': "RCAJO inventory unavailable — you can still add items by name and push them to RCAJO later.",
    'prequal.assessmentNotes': "Assessment notes",
    'prequal.assessmentNotesPlaceholder': "Notes supporting the strategic assessment…",
    'prequal.noNotes': "No notes.",
    'prequal.noCapabilities': "No capabilities mapped yet.",
    'prequal.noCapabilitiesEdit': "Add one below or ask pistache to suggest a strategic assessment.",
    'prequal.addCapabilityPlaceholder': "Add a capability — type to search RCAJO, or enter a new name",
    'prequal.standaloneResources': "Resources (not tied to a capability)",
    'prequal.addResourcePlaceholder': "Add a resource — type to search RCAJO, or enter a new name",
    'prequal.pushNewItems': "Push new items to RCAJO",
    'prequal.pushResultPartial': "Pushed {pushed} item(s); {failed} failed.",
    'prequal.pushResultOk': "Pushed {pushed} new item(s) to RCAJO.",
    'prequal.maturityShort': "maturity {score}",
    'prequal.newCapabilityBadge': "New → will be added to RCAJO",
    'prequal.removeCapability': "Remove capability",
    'prequal.noResources': "No resources mapped.",
    'prequal.askPistacheTitle': "Let pistache draft the reason for this dependency",
    'prequal.askPistache': "Ask pistache",
    'prequal.reasonPlaceholder': 'Why? Type a reason, or click "Ask pistache".',
    'prequal.notInExecution': "Not yet in Execution",
    'prequal.executionCompleted': "Execution completed",
    'prequal.pmoStatusTitle': "PMO-assessed status (Execution)",
    'prequal.problemGoalDeliverables': "Problem · Goal · Deliverables",
    'prequal.problemNeed': "Problem / Need",
    'prequal.goal': "Goal",
    'prequal.deliverables': "Deliverables",
    'prequal.pipelineStageTitle': "Current pipeline stage",
    'prequal.notInRcajo': "not in RCAJO",
    'prequal.notInRcajoTitle': "Referenced by name; not in the RCAJO inventory",
    'prequal.noPredecessors': "no predecessors",
    'prequal.noSuccessors': "no successors",
    'prequal.thisProject': "This project",
    'prequal.dependenciesSequencing': "Dependencies & Sequencing",
    'prequal.checking': " Checking…",
    'prequal.checkWithPistache': " Check with pistache",
    'prequal.sequencingCheckFailed': "Sequencing check failed",
    'prequal.flow': "Flow",
    'prequal.dependsOnProjects': "Depends on — projects",
    'prequal.enablesProjects': "Enables — projects",
    'prequal.declaredElsewhere': "Declared on the other project",
    'prequal.addProjectPlaceholder': "Add a project — type to search",
    'prequal.addResourceSearchPlaceholder': "Add a resource — type to search RCAJO",
    'prequal.referenceNotInRcajo': 'Reference "{q}" (not in RCAJO)',
    'prequal.doNow': "Do now",
    'prequal.sequenceLater': "Sequence later",
    'prequal.suggestedPredecessors': "Suggested predecessors:",
  },
};
